<template>
  <b-card
    no-body
    class="mb-0"
  >
    <div class="m-2">
      <div class="content-box">
        <div
          class="select-box"
          style="margin-bottom: 20px"
        >
          <el-input
            v-model="unitVal"
            placeholder="请输入岗位名称"
            style="width: 200px"
          />
          <el-button
            type="primary"
            @click="seachIt"
            class="ml-2"
          >筛选</el-button>
        </div>
        <div class="table-box">
          <el-table
            :data="tableData"
            class="responsive"
          >
            <el-table-responsive-column
              type="index"
              label="序号"
              width="60"
            />
            <el-table-responsive-column
              prop="name"
              label="岗位名称"
            />
            <el-table-responsive-column
              prop="money"
              label="月薪"
            />
            <el-table-responsive-column
              prop="numberOfNeed"
              label="岗位招聘人数"
            />
            <el-table-responsive-column
              prop="applyNum"
              label="申请人数"
            />
            <el-table-responsive-column
              prop="firstPassNum"
              label="初审聘用人数"
            />
            <el-table-responsive-column
              prop="finalPassNum"
              label="终审聘用人数"
            />
            <el-table-responsive-column
              prop="unitCheckStatus"
              label="审核状态"
            >
              <template slot-scope="scope">
                <span>{{ checkStatusNew(scope.row.unitCheckStatus) }}</span>
              </template>
            </el-table-responsive-column>
            <el-table-responsive-column label="操作">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.unitCheckStatus === 1"
                  type="text"
                  @click="checkIt(scope.row)"
                >审核</el-button>
                <el-button
                  v-else
                  type="text"
                  @click="showIt(scope.row)"
                >查看</el-button>
              </template>
            </el-table-responsive-column>
          </el-table>
        </div>
        <div class="pagantion-box">
          <el-pagination
            :current-page="currentPage + 1"
            :page-size="10"
            layout="total, prev, pager, next"
            :total="totalSize"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import { jobService } from '@/api/index'
import { checkStatusNew, checkName } from '@/tool/utils'

export default {
  name: 'StuCheck',
  data() {
    return {
      currentPage: 0,
      totalSize: 0,
      unitVal: '',
      tableData: [],
    }
  },
  mounted() {
    this.initPage()
  },
  methods: {
    checkStatusNew,
    // 参数
    getPrams() {
      const params = {
        page: this.currentPage,
        size: 10,
        type: 1, // 用工单位为1,
        jobName: this.unitVal,
      }
      return params
    },
    // 筛选
    seachIt() {
      this.currentPage = 0
      this.qureyPage(this.getPrams())
    },
    initPage() {
      const params = this.getPrams()
      this.qureyPage(params)
    },
    qureyPage(params) {
      if (!checkName(this.unitVal)) {
        jobService()._schoolOrUnit(params).then(res => {
          if (res.status) {
            this.tableData = res.data.content
            this.totalSize = res.data.totalElements
          }
        })
      } else {
        this.$message.warning('请输入正确单位或岗位名称')
      }
    },
    checkIt(row) {
      this.$router.push({
        name: 'checkPage', query: {
          id: row.id, jobName: row.name, needNum: row.numberOfNeed, firstPassNum: row.firstPassNum, finalPassNum: row.finalPassNum,
        },
      })
    },
    showIt(row) {
      this.$router.push({
        name: 'showDetail', query: {
          id: row.id, jobName: row.name, needNum: row.numberOfNeed, firstPassNum: row.firstPassNum, finalPassNum: row.finalPassNum,
        },
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val - 1
      this.qureyPage(this.getPrams())
    },
  },
}
</script>

<style scoped>
</style>
